import axios from "axios";
import configs from "../config";

const publicAxios = axios.create({
   baseURL: configs.API_BASE_URL,
   withCredentials: false,
});

const getActiveAnnouncements = async () => {
   return await publicAxios.get(`/announcements/active`);
};

const announcementApiServices = {
   getActiveAnnouncements,
};

export default announcementApiServices;
